exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".purchaseOrderInput .contactInfoField{font-weight:400;width:100%;margin-bottom:2rem}.purchaseOrderInput .contactInfoField .form-control{margin-top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/payments/purchase_order_input.scss
// module id = 1348
// module chunks = 0